import { Box, Container, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { TABS } from "../App";
import { useAuth } from "../hooks/useAuth";

export default function Error404() {
  const location = useLocation();
  const [content, setContent] = useState<any>(null);
  const navigate = useNavigate();

  const { isLogged } = useAuth();
  useEffect(() => {
    const name: string = location.pathname.slice(1);
    const uris = TABS.map((tab) => tab.uri);
    if (uris.includes(name as any)) {
      navigate(location.pathname);
    } else {
      setContent(
        <Box overflow={"auto"} height={"100%"} width={"100%"}>
          <Container
            maxWidth="xl"
            sx={{
              py: 2,
              height: "100%",
              maxHeight: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <img
              height={128}
              width={128}
              src="./img/trendrating_icon_transparent_128x128_black.png"
              alt="trendrating logo"
            />
            <Typography pt={5} variant="subtitle1">
              Page not found!
            </Typography>
          </Container>
        </Box>
      );
    }
  }, [isLogged, location.pathname, navigate]);
  return content;
}
